import { ActionTypes } from '../constants/ActionTypes';
import { AnyAction } from 'redux';
import { IVisitInfo } from '../models/IVisitInfo';

export function SetVisitInfo(data: IVisitInfo): AnyAction {
    return {
        type: ActionTypes.SET_VISIT_INFO,
        payload: data
    }
}


// WEBPACK FOOTER //
// ./src/actions/VisitActions.tsx